angular.module("app").controller("CasinoGamesEditPageController", [
    '$scope',
    'casinoGameService',
    'errorHandler',
    'preloadedCategories',
    'logger',
    'preloadedGameData',
    'deepCompare',
    '$uibModalInstance',
    'casinoLabels',
    'settingsService',
    'currencies',
    function ($scope, casinoGameService, errorHandler, preloadedCategories, logger, preloadedGameData, deepCompare, $modalInstance, casinoLabels, settingsService, currencies) {
        var init,
            addElementHelper = null,
            preloadedBackgroundDefaultId  = null,
            preloadedIconDefaultId  = null;
        var settings = settingsService.getSettings();
        $scope.isLicense = settings.skin.use_game_license_image;
        $scope.hasCasinoBetLimits = settings.skin.has_casino_bet_limits;
        $scope.hasCasinoRegulationInfo = settings.skin.has_casino_regulation_info;
        $scope.currencies = $scope.hasCasinoBetLimits ? currencies.data.map(function(item){
            return {id: item.key, title: item.value}
        }): [];

        $scope.casinoImageType = settings.skin.casino_image_type;

        $scope.tooltip = {
            name: "",
            height: "",
            width: ""
        };
        $scope.casinoLabels = casinoLabels;
        $scope.show_on_page = angular.copy(['home']); //Will be changed
        preloadedGameData.badge =  preloadedGameData.badge || "";

        var preSelectedCategores;
        var deletedIds = [];

        $scope.save = function () {
            if (!$scope.edit_games_form.$valid) {
                return;
            } else if($scope.isAllowedToUpdate()) {
                logger.logError("global.no_changes");
                return;
            }
            addElementHelper = addElementHelper || $scope.useAddElementHelper();
            var fetchedData = fetchRequestData();
            delete fetchedData.background;
            delete fetchedData.icon;
            var requestData = {
                    skinGame: angular.copy(fetchedData)
                };

            casinoGameService.editSkinGame(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("updated");
                        preloadedGameData = angular.copy(fetchedData);
                        $modalInstance.close();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        /**
         * Extract needed data from game response
         * @param game
         */
        function extractGame(game) {
            if (!game.background) {
                var image = null;
                if (!!game["icon_1"]) {
                    image = game["icon_1"];
                } else if (!!game["icon_2"]) {
                    image = game["icon_2"];
                } else if (!!game["icon_3"]) {
                    image = game["icon_3"];
                }

                if (game.default) {
                    $scope.selectedIconDefaultId = preloadedIconDefaultId = game.id;
                }
                return {
                    global: game.global,
                    src: image,
                    id: game.id
                }
            }
            else {
                if (game.default) {
                    $scope.selectedBackgroundDefaultId = preloadedBackgroundDefaultId = game.id;
                }
                return {
                    background: game.background,
                    id: game.id
                }
            }
        }

        $scope.selectDefaultImages = function (section) {
            if (section.icon) {
                $scope.selectedIconDefaultId = section.icon;

                if ($scope.selectedIconDefaultId !== preloadedIconDefaultId && $scope.selectedIconDefaultId > 0) { // uploads has negative ids
                    $scope.gameData.icon_id = $scope.selectedIconDefaultId
                } else {
                    delete $scope.gameData.icon_id;
                }

            } else if (section.background) {

                $scope.selectedBackgroundDefaultId = section.background;

                if ($scope.selectedBackgroundDefaultId !== preloadedBackgroundDefaultId) {
                    $scope.gameData.background_id = $scope.selectedBackgroundDefaultId
                } else {
                    delete $scope.gameData.background_id;
                }
            }
        };

        $scope.isAllowedToUpdate = function () {
            var requestData = fetchRequestData();
            var result = true;

            if(!deepCompare.isEqual(preSelectedCategores, requestData.categories)){
                result = false;
            }

            requestData.categories = preloadedGameData.categories;
            result = result && deepCompare.isEqual(requestData, preloadedGameData);
            return result;
        };

        function fetchRequestData () {
            var fetchedData = angular.extend({}, $scope.gameData);
            addElementHelper = addElementHelper || ($scope.useAddElementHelper && $scope.useAddElementHelper());
            if (addElementHelper) {
                fetchedData.categories =  addElementHelper.fetchData('selectedCategories');
            }

            if ($scope.icons) {
                fetchedData.customIcons = $scope.icons.filter(function (icon) {
                    return icon.src.indexOf('data:image') !== -1;
                }).map(function (icon) {
                    return {
                        icon: icon.src,
                        default: icon.id === $scope.selectedIconDefaultId,
                        id: icon.id > 0 ? icon.id : undefined
                    }
                });
            }

            var betLimits = Object.entries(addElementHelper.fetchData('betLimits') || {});
            if(betLimits.length){
                fetchedData.bet_limits = {};
                betLimits.forEach(function(item){
                    var limits = item[1].split("-");
                    var min = limits[0];
                    var max = limits[1];
                    fetchedData.bet_limits[item[0]] = {min: min, max: max};
                });
            }else {
                fetchedData.bet_limits = null;
            }


            if(deletedIds.length){
                fetchedData.deletedIds = deletedIds;
            }

            return fetchedData
        }

        (init = function (gameData) {
            $scope.categories = angular.copy(preloadedCategories);

            $scope.selectedCategories = (function () {
                var fetchedData = {};
                gameData.categories.forEach(function (category) {
                    fetchedData[category.id] = category.expiration_date || '';
                });
                return fetchedData
            })();

            if(gameData.bet_limits){
                var betLimits = {};

                Object.entries(gameData.bet_limits).forEach(function(item){
                    betLimits[item[0]] = item[1].min+ "-" + item[1].max;
                })

                $scope.betLimits = betLimits;
            }

            preSelectedCategores = angular.copy($scope.selectedCategories);
            if (Object.keys(preSelectedCategores).length === 0) {
                preSelectedCategores = undefined;
            }

            gameData.categories = angular.copy($scope.categories);
            $scope.gameData = angular.copy(gameData);
            $scope.backgrounds = angular.copy(preloadedGameData.background).map(extractGame);
            if ($scope.isLicense){
                $scope.licenseIcons = preloadedGameData.licenseIcons? angular.copy(preloadedGameData.licenseIcons).map(extractGame): [];
            } else {
                $scope.icons = angular.copy(preloadedGameData.icon).map(extractGame);
                $scope.uploadCache = {
                    icon: [],
                    customIcon: [],
                };

                $scope.deleteIcon = function (id) {
                    var deleteIndex = $scope.icons.findIndex(function (icon){
                        return icon.id === id;
                    });

                    var selectedIndex = $scope.icons.findIndex(function (icon){
                        return icon.id === $scope.selectedIconDefaultId;
                    });

                    $scope.icons.splice(deleteIndex, 1);
                    if ($scope.selectedIconDefaultId === id) {
                        $scope.selectedIconDefaultId = $scope.icons[0].id;
                    } else if (selectedIndex > deleteIndex) {
                        $scope.selectedIconDefaultId = $scope.icons[selectedIndex - 1].id;
                    }

                    if(id && id > 0) { // negative ids teporary for uploades
                        deletedIds.push(id);
                    };
                };

                $scope.$watch('uploadCache.icon', function () {
                    if ($scope.uploadCache.icon && angular.isString($scope.uploadCache.icon)) {
                        var newIcon = {src: $scope.uploadCache.icon, global: false, id: "-" + Date.now()};
                        $scope.icons.push(newIcon);
                        $scope.uploadCache.icon = false;
                        $scope.selectDefaultImages({icon: newIcon.id})
                    }
                });

                $scope.$watch("icons.length", function (){
                    $scope.customIconsCount = $scope.icons.filter(function (icon) {
                        return !icon.global
                    }).length;
                });
            }

            $scope.gameData.show_on_page = $scope.gameData.show_on_page || [];
        })(preloadedGameData);

        $scope.close = function () {
            $modalInstance.dismiss('cancel');
        };

    }
]);
